import React from "react";
import TextField from "../../../../../components/TextField/TextField";
import FormModal from "../../../../../components/FormModal/FormModal";
import { Box, Avatar, Typography, IconButton, Button } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";
import PersonAddIcon from "@mui/icons-material/PersonAdd";

function DialogSearch({
  claimModalVisible,
  handleClaimModalVisibility,
  formik,
  searchUser,
  deleteFoundUser,
  onClick,
  title = "Agregar miembro",
  sendButtonLabel = "ENVIAR",
}) {
  const handleClose = () => {
    deleteFoundUser();
    handleClaimModalVisibility();
  };

  return (
    <FormModal 
      open={claimModalVisible} 
      onClose={handleClose} 
      title={title}
      maxWidth="sm"
      fullWidth={true}
    >
      <Box sx={{ mt: 1, mb: 2 }}>
        <Typography sx={{ fontSize: '13.5px', color: '#64748B', fontFamily: 'Roboto, sans-serif', mb: 2.5, lineHeight: 1.5 }}>
          Ingrese la cédula o pasaporte del usuario registrado en el portal para vincularlo a su empresa:
        </Typography>

        <Box sx={{ display: 'flex', gap: 1.5, alignItems: 'flex-start', width: '100%', mb: 3 }}>
          <Box sx={{ flex: 1 }}>
            <TextField
              id="citizen_id"
              title="Buscar por cédula o pasaporte"
              mask="99999999999999999999"
              value={formik.values.citizen_id}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.citizen_id && Boolean(formik.errors.citizen_id)}
              helperText={formik.touched.citizen_id && formik.errors.citizen_id}
              required
            />
          </Box>
          <Button
            variant="outlined"
            onClick={formik.handleSubmit}
            startIcon={<SearchIcon />}
            sx={{
              mt: '24px',
              height: '46px',
              borderRadius: '10px',
              borderColor: '#0F2350',
              color: '#0F2350',
              fontWeight: 700,
              textTransform: 'none',
              px: 2.5,
              whiteSpace: 'nowrap',
              '&:hover': {
                borderColor: '#EA361A',
                color: '#EA361A',
                backgroundColor: 'rgba(234, 54, 26, 0.04)'
              }
            }}
          >
            Buscar
          </Button>
        </Box>

        {searchUser && (
          <Box sx={{ 
            display: 'flex', 
            alignItems: 'center', 
            bgcolor: '#F0F9FF', 
            border: '1.5px solid #BAE6FD', 
            borderRadius: '14px', 
            p: 2, 
            mb: 3, 
            gap: 2,
            position: 'relative'
          }}>
            <Avatar sx={{ 
              bgcolor: '#0F2350', 
              width: '46px', 
              height: '46px',
              fontSize: '18px',
              fontWeight: 'bold',
              fontFamily: 'Roboto, sans-serif'
            }}>
              {searchUser.name?.substring(0, 1).toUpperCase()}
            </Avatar>
            <Box sx={{ flex: 1 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
                <Typography variant="body1" sx={{ fontWeight: 700, color: '#0F2350', fontFamily: 'Roboto, sans-serif', fontSize: '15px' }}>
                  {`${searchUser.name || ''} ${searchUser.first_last_name || ''}`}
                </Typography>
                <Box sx={{ 
                  px: 1, 
                  py: 0.2, 
                  bgcolor: '#DCFCE7', 
                  color: '#15803D', 
                  borderRadius: '6px', 
                  fontSize: '11px', 
                  fontWeight: 700 
                }}>
                  Usuario Encontrado
                </Box>
              </Box>
              <Typography variant="body2" sx={{ fontSize: '13px', color: '#64748B', fontFamily: 'Roboto, sans-serif' }}>
                Cédula/Pasaporte: <strong>{searchUser.citizen_id}</strong>
              </Typography>
            </Box>
            <IconButton 
              aria-label="quitar"
              onClick={deleteFoundUser}
              sx={{ 
                color: '#64748B',
                '&:hover': { color: '#DC2626', backgroundColor: '#FEF2F2' }
              }}
            >
              <CloseIcon sx={{ fontSize: '18px' }} />
            </IconButton>
          </Box>
        )}

        <Box sx={{ width: '100%', display: 'flex', justifyContent: 'flex-end', gap: 1.5, borderTop: '1px solid #E2E8F0', pt: 2.5 }}>
          <Button
            variant="outlined"
            onClick={handleClose}
            sx={{
              borderRadius: '10px',
              borderColor: '#CBD5E1',
              color: '#64748B',
              textTransform: 'none',
              fontWeight: 700,
              px: 3,
              py: 1,
              '&:hover': {
                borderColor: '#94A3B8',
                backgroundColor: '#F8FAFC'
              }
            }}
          >
            Cancelar
          </Button>
          <Button 
            variant="contained"
            disabled={!searchUser} 
            onClick={onClick} 
            startIcon={<PersonAddIcon />}
            sx={{
              bgcolor: '#0F2350',
              color: '#FFFFFF',
              borderRadius: '10px',
              textTransform: 'none',
              fontWeight: 700,
              px: 3,
              py: 1,
              boxShadow: 'none',
              '&:hover': {
                bgcolor: '#EA361A',
                boxShadow: 'none'
              },
              '&.Mui-disabled': {
                bgcolor: '#E2E8F0',
                color: '#94A3B8'
              }
            }}
          >
            {sendButtonLabel}
          </Button>
        </Box>
      </Box>
    </FormModal>
  );
}

export default DialogSearch;
